export function sumBy<T>(input: T[], property: keyof T) {
  return input.reduce((agg, curr) => {
    agg += (curr[property] as unknown) as number;
    return agg;
  }, 0);
}

export const pipe = (...fns: any) => (value: any) =>
  fns.reduce((value: any, func: any) => func(value), value);

export function max<T>(input: T[], property: keyof T) {
  return input.reduce((agg: undefined | number, curr) => {
    const currentValue = (curr[property] as unknown) as number;
    return !agg || agg < currentValue ? currentValue : agg;
  }, undefined);
}
